module.exports = "https://static.im-cdn.com/mjc/storefront/Simplar/static/media/no-profile.4859d91c.png";